import { defineStore } from "pinia";
import { ILimitCalculationSendComponentObject } from "nlb-buy-go-library";

interface ILimitCalculationState {
    SendData: ILimitCalculationSendComponentObject;
}

export const useLimitCalculationStore = defineStore("limitCalculation", {
    state: (): ILimitCalculationState => ({
        SendData: {
            email: undefined,
            phoneNumber: undefined,
            prefix: undefined,
            msisdn: undefined,
        },
    }),

    actions: {
        reset() {
            this.SendData = {
                email: undefined,
                phoneNumber: undefined,
                prefix: undefined,
                msisdn: undefined,
            };
        },

        updateSendData(data: ILimitCalculationSendComponentObject) {
            this.SendData = { 
                ...this.SendData,
                ...data 
            };
        },
    },
});
